// LeagueFeesRadioGroup.js
import styles from "./LeagueFeesRadioGroup.module.css";
import React, { useState } from 'react';
import RadioButton from './RadioButton';

const LeagueFeesRadioGroup = () => {
  const [selectedValue, setSelectedValue] = useState('');

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  return (
    <div>
      <RadioButton
        name="leagueFeesYesNoGroup"
        value="Yes"
        checked={selectedValue}
        onChange={handleChange}
      />
      <RadioButton
        name="leageuFeesYesNoGroup"
        value="No"
        checked={selectedValue}
        onChange={handleChange}
      />
    </div>
  );
};

export default LeagueFeesRadioGroup;


